import axios from "axios";
import handleError from "../../../utils/handleError";
import { GetDriverByOwnerIdRequestBuilder } from "client-sdk/src/entrances/getDriverById";
import Client from "client-sdk/src/client";
// export default const getDrivers = () => {

// }

const token = localStorage.getItem("token");

export async function getDriverByOwnerId(id: any) {
  try {
    const getVehicleOwner = new GetDriverByOwnerIdRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token as string);
    const response = client.execute(
      getVehicleOwner,
    );
    return response;
  } catch (error) {
    return handleError(error.response);
  }
}

export default getDriverByOwnerId;
